export const USER_AUTH_VALIDATING = "USER_AUTH_VALIDATING";
export const USER_AUTH_DONE_VALIDATING = "USER_AUTH_DONE_VALIDATING";
export const USER_RECEIVE_DETAILS_AND_TOKEN = "USER_RECEIVE_DETAILS_AND_TOKEN";
export const USER_RECEIVE_NEW_EMAIL = "USER_RECEIVE_NEW_EMAIL";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const USER_ID = "USER_ID";
export const USER_FACEBOOK_AUTH = "USER_FACEBOOK_AUTH";
export const USER_ACCEPT_TOC = "USER_ACCEPT_TOC";

export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";

export const USER_HYDRATE = "USER_HYDRATE";

export const FINISH_ONBOARDING = "FINISH_ONBOARDING";

// Flux standard actions should have a starting, done, and failed
// These boiler plate codes can be removed by using some libraries
// like redux-actions
export const VALIDATE_USER_RESET_PASSWORD_TOKEN_START = "VALIDATE_USER_RESET_PASSWORD_TOKEN_START";
export const VALIDATE_USER_RESET_PASSWORD_TOKEN_DONE = "VALIDATE_USER_RESET_PASSWORD_TOKEN_DONE";
export const VALIDATE_USER_RESET_PASSWORD_TOKEN_FAILED = "VALIDATE_USER_RESET_PASSWORD_TOKEN_FAILED";
export const RESET_USER_PASSWORD_START = "RESET_USER_PASSWORD_START";
export const RESET_USER_PASSWORD_DONE = "RESET_USER_PASSWORD_DONE";
export const RESET_USER_PASSWORD_FAILED = "RESET_USER_PASSWORD_FAILED";
export const USER_RESET_PASSWORD_TOKEN_EXPIRED = "USER_RESET_PASSWORD_TOKEN_EXPIRED";



// WEBPACK FOOTER //
// ./src/features/user/actionTypes.js